import { Box, Typography } from '@mui/material';
import { FC, Fragment, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as FailureIconVs } from 'src/assets/svg/failure-red-circle.svg';
import { ReactComponent as FailureIconHos } from 'src/assets/svg/failure-red-circle-hos.svg';
import { Button } from 'src/components/button';
import { removeStorage } from 'src/utils/local-storage-versioning';
import { appConfig } from 'src/app';
import { getTheme } from 'src/utils/getTheme';

import { styles } from './styles';

const { isHosTheme } = getTheme();

const FailureIcon: FC = () => (isHosTheme ? <FailureIconHos /> : <FailureIconVs />);

const TextWrapper: FC<{ children: ReactNode }> = (props) => {
    const Wrapper = isHosTheme ? Box : Fragment;

    return <Wrapper>{props.children}</Wrapper>;
};

export const RoomNotAvailable: FC = () => {
    const { t } = useTranslation();
    const { vs, hos } = appConfig.brochureSiteUrl;
    removeStorage();

    return (
        <Box css={styles.container}>
            <Box css={styles.imageContainer} />

            <Box css={styles.wrapper}>
                <FailureIcon />

                <TextWrapper>
                    <Typography variant="h1" css={styles.title}>
                        {t('room_not_available_title')}
                    </Typography>

                    <Typography variant="body3">{t('room_not_available_content')}</Typography>
                </TextWrapper>

                <Button
                    {...(isHosTheme && { design: 'light', bordered: true })}
                    css={styles.cta}
                    href={isHosTheme ? hos : vs}
                >
                    {t('room_not_available_btn')}
                </Button>
            </Box>
        </Box>
    );
};
